import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme';
import { Heading, Text, TrendUpIcon } from '@weave/design-system';
import { RecommendedConnection } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/v2/insurance_verification_adapter.pb';

type RecommendedConnectionsProps = {
  connections?: RecommendedConnection[];
};

export const RecommendedConnections = ({ connections }: RecommendedConnectionsProps) => {
  if (!connections || connections.length === 0) {
    return null;
  }

  return (
    <section css={containerStyles}>
      <Heading level={3} css={headingStyles}>
        Recommended Connections
      </Heading>
      <Text size="medium" color="subdued" css={subtitleStyles}>
        Connect these payers to increase your web coverage
      </Text>
      <div css={connectionsListStyles}>
        {connections.map((connection, index) => (
          <div key={index} css={connectionItemStyles}>
            <div css={payerInfoStyles}>
              <Text size="large" weight="bold" css={payerNameStyles}>
                {connection.payerName}
              </Text>
            </div>
            <div css={gainStyles}>
              <Text size="large" weight="bold" css={gainTextStyles}>
                +{connection.potentialGainPercentage}%
              </Text>
              <TrendUpIcon size={20} color="success" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

const containerStyles = css({
  borderRadius: theme.borderRadius.medium,
  border: `1px solid ${theme.colors.neutral50}`,
  padding: theme.spacing(3),
  marginTop: theme.spacing(3),
  backgroundColor: theme.colors.white,
});

const headingStyles = css({
  margin: 0,
  marginBottom: theme.spacing(0.5),
});

const subtitleStyles = css({
  marginBottom: theme.spacing(2),
});

const connectionsListStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
});

const connectionItemStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderRadius: theme.borderRadius.small,
  backgroundColor: theme.colors.neutral5,
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.colors.neutral10,
  },
});

const payerInfoStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
});

const payerNameStyles = css({
  margin: 0,
});

const gainStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
});

const gainTextStyles = css({
  margin: 0,
  color: theme.colors.success50,
});
